
import Interface from '../../lib'
const tabs = {
    state: {
        // 医院介绍
        hospitalIntro: 0,
        // 消息中心
        messageCenter: 0,
        // 缴费记录
        paymentRecord: 0,
        // 挂号科室选择
        departmentCurrentIndex: 0,
        // 挂号类型选择
        outPatient: 'department',
        // 时间段选择组件
        datesSelect: {
            label: '',
            value: []
        },
        // 星期时间选择组件
        weekDate: ''
    },
    mutations: {
        setHospitalIntro(state, data){
            state.hospitalIntro = data;
        },
        setMessageCenter(state, data){
            state.messageCenter = data;
        },
        setPaymentRecord(state, data){
            state.paymentRecord = data;
        },
        setOutPatient(state, data){
            state.outPatient = data;
        },
        setDepartmentCurrentIndex(state, data){
            state.departmentCurrentIndex = data;
        },
        setDatesSelect(state, data){
            state.datesSelect = data;
        },
        resetDatesSelect(state, data){
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            let dates = {
                label: '近三天',
                value: [
                    start.format("yyyy-MM-dd"),
                    new Date().format("yyyy-MM-dd")
                ]
            }
            state.datesSelect = dates;
        },
        setWeekDate(state, data){
            state.weekDate = data;
            sessionStorage.setItem("weekDate",  data);
        },
        resetWeekDate(state, data){
            if (state.weekDate) {
                state.weekDate = sessionStorage.getItem("weekDate")
            } else {
                state.weekDate = new Date().format("yyyy-MM-dd");
                sessionStorage.setItem("weekDate",  new Date().format("yyyy-MM-dd"));
            }
        },
    }
}
export default tabs


// WEBPACK FOOTER //
// ./src/store/modules/tabs.js